import 'magnific-popup';

$('.js-popup-video').magnificPopup({
  disableOn: 767,
  type: 'iframe',
  mainClass: 'popup-video mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});
